import { connect } from 'react-redux';
import cn from 'classnames';

function AlertStatic({ message, alertType, link }) {
    return (
        <div className={cn('alert', alertType)}>{message}
            { link && (
                <a href={link.href} target={'_blank'}>{link.title || link.href}</a>
            ) }
        </div>
    );
}

export default connect(null, null)(AlertStatic);
